export const TRANSACTION_CANCELLED = 4001;
